import { type Room } from "matrix-js-sdk/src/matrix";

import { type ActionPayload } from "../payloads";
import { type Action } from "../actions";

export enum SpacePreferenceTab {
    Appearance = "SPACE_PREFERENCE_APPEARANCE_TAB",
}

export interface OpenSpacePreferencesPayload extends ActionPayload {
    action: Action.OpenSpacePreferences;

    /**
     * The space to open preferences for.
     */
    space: Room;

    /**
     * Optional tab to open specifically, otherwise the dialog's internal default.
     */
    initialTabId?: SpacePreferenceTab;
}
